import { render, staticRenderFns } from "./RegisterBookForm.vue?vue&type=template&id=598bc308&"
import script from "./RegisterBookForm.vue?vue&type=script&lang=js&"
export * from "./RegisterBookForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports